import { fromJS, List, Map } from 'immutable'
import React, { Component } from 'react'

import scrollTo from 'animated-scroll-to'
import { api } from '../common/api'
import Footer from './footer'
import Header from './header'
import MaterialList from './list'
import MaterialPreview from './preview'
import SubmittedPage from './submitted'

import LanguageSwitcher from '../common/languageSwitcher'
import { useTranslator } from '../common/translator'

class Approve extends Component {
  constructor(props) {
    super(props)

    let { preview = false, view = 'default' } = window.location.search
      .substr(1)
      .split('&')
      .reduce((mapped, str) => {
        let [key, value] = str.split('=')
        mapped[key] = value
        return mapped
      }, {})

    if (view === 'admin') preview = true

    this.state = {
      loading: true,
      info: Map(),
      error: false,
      openMaterialId: false,
      openGroupId: false,
      openGroupValidationError: false,
      submitted: false,
      consentError: false,
      notfound: false,
      preview,
      view,
    }
  }

  componentDidMount() {
    let { match: { params: { approve_id } = {} } = {} } = this.props
    let { preview } = this.state

    window.addEventListener('beforeunload', this.handleBeforeUnload)

    api
      .get(`/dashboard/approve/${approve_id}`, preview ? { preview: 1 } : {})
      .then(({ data }) => {
        let { info = {} } = data
        info.materials = info.materials || []

        info.groups = info.materials.reduce(
          (groups, material) => {
            let { file = {} } = material
            let { type = '' } = file.meta || {}
            if (type.startsWith('video')) groups.video.push(material)

            if (type.startsWith('image')) groups.image.push(material)

            if (material.type === 'article') groups.article.push(material)

            return groups
          },
          {
            video: [],
            image: [],
            article: [],
          }
        )

        this.setState({
          loading: false,
          info: fromJS(info),
        })
      })
      .catch(err => {
        this.setState({
          loading: false,
          error: 'notFound',
          notfound: true,
        })

        window.catchError(err)
      })
  }

  handleBeforeUnload = e => {
    let { t } = this.props
    let { openGroupId, submitted } = this.state
    if (openGroupId !== false && !submitted) {
      e.preventDefault()
      e.returnValue = t('approve.unsavedChangesPreventPage')
    }
  }

  handleMaterialCommentChange = (materialId, values) => {
    let { info } = this.state
    let comments = info.get('comments', Map())

    this.setState({
      info: info.set('comments', comments.set(materialId, values)),
    })
  }

  handleMaterialApproveChange = (id, value) => {
    let { info } = this.state
    let approves = info.get('approves', Map())

    this.setState(
      {
        info: info.set('approves', approves.set(id, value)),
        openGroupValidationError: false,
      },
      () => {
        if (value) {
          let nextButton = document.getElementById('action-next')
          return nextButton ? nextButton.focus() : false
        }

        let comments = document.querySelectorAll('.comment-notes')
        let firstComment = comments[0] || false
        if (!firstComment) return

        scrollTo(firstComment, { element: this._content, offset: -200 })

        this._content.classList.add('highlight-comments')
        setTimeout(() => this._content.classList.remove('highlight-comments'), 2400)
      }
    )
  }

  validateGroup = groupId => {
    let { info } = this.state
    let group = info.getIn(['groups', groupId], Map())
    let comments = info.get('comments', Map())
    return group.reduce((hasComment, item) => {
      if (hasComment) return true
      let comment = comments.get(item.get('id'), false)
      return typeof comment === 'string' && comment.trim() !== ''
    }, false)
  }

  changeGroup = (openGroupId, validateGroupId) => {
    if (validateGroupId && !this.validateGroup(validateGroupId))
      return this.setState({
        openGroupValidationError: true,
      })

    if (this._content) this._content.scrollTop = 0

    this.setState({ openGroupId, openGroupValidationError: false })
  }

  handleSubmit = () => {
    let { match: { params: { approve_id } = {} } = {} } = this.props

    let { comments, approves, consent, feedback, canSubmit } = this.getInfo()

    if (!canSubmit)
      return this.setState({
        consentError: true,
      })

    this.setState({
      submitting: true,
    })

    api
      .post(`/dashboard/approve/${approve_id}`, {
        approves: approves.toJS(),
        comments: comments.toJS(),
        feedback,
        consent,
      })
      .then(({ data }) => {
        this.setState({
          submitting: false,
          submitted: data.success === true,
          error: data.success !== true ? 'saveError' : false,
        })
      })
      .catch(err => {
        console.log(err)
        this.setState({
          submitting: false,
          submitted: false,
          error: 'saveError',
        })

        window.catchError(err)
      })
  }

  getInfo = () => {
    let { info } = this.state

    let data = {}
    data.approvedAt = info.get('approved_at', null)
    data.groups = info.get('groups', Map())
    data.materials = info.get('materials', List())
    data.comments = info.get('comments', Map())
    data.approves = info.get('approves', Map())
    data.status = info.get('status')
    data.isClient = info.get('isClient', false)
    data.hasRelated = info.get('hasRelated', false)
    data.reopened = info.get('reopened', false)
    data.message = info.get('message')
    data.consent = info.get('consent', false)
    data.feedback = info.get('feedback')

    data.canSubmit = data.groups.reduce(
      (canSubmit, group, id) =>
        canSubmit === false ? canSubmit : group.size && data.approves.get(id) === undefined ? false : true,
      true
    )
    data.isApproved = data.canSubmit && data.approves.reduce((isApproved, val) => (!val ? false : isApproved), true)
    data.showConsent = false

    if (data.canSubmit && data.isApproved && !data.isClient) {
      data.canSubmit = data.consent === true
      data.showConsent = true
    }

    return data
  }

  render() {
    let {
      loading,
      info,
      error,
      openGroupId,
      openGroupValidationError,
      submitting = false,
      submitted = false,
      consentError,
      preview,
      notfound,
    } = this.state

    let { t, brand = 'kokemuksia', lang, languages, setLanguage, catchedError } = this.props

    if (catchedError) error = catchedError

    if (loading)
      return (
        <div className="approve-page approve-page--loading">
          <div className="approve-loader">
            <i className="fa fa-spin fa-spinner" />
          </div>
        </div>
      )

    let data = this.getInfo()

    let openGroup = openGroupId ? data.groups.get(openGroupId, false) : false

    let classes = ['approve-page']
    if (openGroup) classes.push('approve-page--material-open')

    let nextGroupMapping = {
      video: 'image',
      image: 'article',
      article: 'final',
    }

    let nextGroup = false
    let nextCandidate = nextGroupMapping[openGroupId] || 'video'

    while (!nextGroup) {
      if (nextCandidate === 'final') nextGroup = nextCandidate

      if (data.groups.get(nextCandidate, List()).size) nextGroup = nextCandidate

      nextCandidate = nextGroupMapping[nextCandidate] || 'final'
    }

    if (!nextGroup) nextGroup = 'final'

    let props = {
      validationError: openGroupValidationError,
      brand,
      group: openGroup,
      groupId: openGroupId,
      nextGroup: nextGroup,
      changeGroup: this.changeGroup,
      onCommentChange: this.handleMaterialCommentChange,
      onApproveChange: this.handleMaterialApproveChange,
      t,
      error,
      setLanguage,
      languages,
      lang,
      preview,
      handleSubmit: this.handleSubmit,
      consentError,
      submitting,
      submitted,
      notfound,
      onFeedbackChange: e => this.setState({ info: info.set('feedback', e.target.value) }),
      onConsentChange: checked => this.setState({ info: info.set('consent', checked) }),
      onClick: id => this.setState({ openGroupId: id }),
      ...data,
    }

    return (
      <div className={classes.join(' ')}>
        <Header {...props} />
        <div className="approve-content" ref={el => (this._content = el)}>
          {error ? (
            <div className="approve-error-wrapper">
              <div className="approve-message approve-message--error">
                <i className="fa fa-exclamation-triangle" />
                {t(`approve.errorMessage.${typeof error === 'string' ? error : 'default'}`)}
              </div>
            </div>
          ) : null}
          {!openGroup && nextGroup !== 'final' ? (
            <div className="approve-lang-switch">
              <LanguageSwitcher {...props} />
            </div>
          ) : null}
          {notfound ? null : submitted ? (
            <SubmittedPage {...props} />
          ) : openGroup ? (
            <MaterialPreview {...props} />
          ) : (
            <MaterialList {...props} />
          )}
        </div>
        <Footer {...props} />
      </div>
    )
  }
}

function ApproveTranslator(props) {
  const translatorState = useTranslator()
  return <Approve {...props} {...translatorState} />
}

export default class ApprovalErrorCatcher extends Component {
  state = {
    catchedError: false,
  }

  componentDidCatch(error, info) {
    window.catchError(error)
    this.setState({
      catchedError: 'systemError',
    })
  }

  render() {
    let { catchedError } = this.state

    if (catchedError)
      return (
        <div className="global-error">
          <div className="global-error-message">
            <i className="fa fa-exclamation-triangle" />
            <span>System error</span>
          </div>
        </div>
      )

    return <ApproveTranslator {...this.props} />
  }
}
